import { trackEvent } from './trackEvent';

export const TRACKER_STOP_TIME = 300; // 5 minutes;

/**
 * Exposed for TESTING ONLY!
 * Singleton object should be used
 */
//
export class PageDwellTracker {
    private elapsedTime: number = 0;
    private lastTrackedSecond: number = 0;
    private startTimestamp: number = 0;
    private timeoutId?: NodeJS.Timer;
    private hasStarted: boolean = false;

    constructor() {
        this.visibilityChangeHandler = this.visibilityChangeHandler.bind(this);
        this.startTracking = this.startTracking.bind(this);
        this.track = this.track.bind(this);
        this.stop = this.stop.bind(this);
    }

    private track(): void {
        const currentTimestamp = new Date().getTime();
        this.elapsedTime += currentTimestamp - this.startTimestamp;
        this.startTimestamp = currentTimestamp;

        // Get full second of dwell time
        let secondToTrack = Math.floor(this.elapsedTime / 1000);

        // Should track each second until 30, then each 10th, e.g 1 2 3 .. 28 29 30 40 50 .. 280 290 300
        secondToTrack = secondToTrack > 30 ? secondToTrack - (secondToTrack % 10) : secondToTrack;

        if (secondToTrack > this.lastTrackedSecond) {
            this.lastTrackedSecond = secondToTrack;
            trackEvent({
                category: 'dwell time',
                action: 'seconds elapsed',
                label: this.lastTrackedSecond,
            });

            if (this.lastTrackedSecond >= TRACKER_STOP_TIME) {
                this.stop();
            }
        }
    }

    private startTracking(): void {
        // Order is important here. Track function should be able to clear this timeout if tracking has to be stopped
        this.timeoutId = setTimeout(this.startTracking, 500);
        this.track();
    }

    private visibilityChangeHandler(): void {
        if (document.hidden) {
            this.track();
            clearTimeout(this.timeoutId);
        } else {
            this.startTimestamp = new Date().getTime();
            this.startTracking();
        }
    }

    private reset(): void {
        clearTimeout(this.timeoutId);
        this.elapsedTime = 0;
        this.lastTrackedSecond = 0;
        this.startTimestamp = new Date().getTime();
        if (!document.hidden) {
            this.startTracking();
        }
    }

    private stop(): void {
        clearTimeout(this.timeoutId);
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    }

    start(): void {
        if (this.hasStarted) {
            return;
        }
        this.reset();
        document.addEventListener('visibilitychange', this.visibilityChangeHandler);
        this.hasStarted = true;
    }

    resetIfStarted(): void {
        if (this.hasStarted) {
            this.reset();
        }
    }
}

export const pageDwellTracker = new PageDwellTracker();
